<template>
  <div id="documents">
    <Breadcrumbs
      :crumbs="[
        { name: globals.info.school_name, link: `${pathPrefix}/` },
        { name: sectionName, link: `${pathPrefix}/documents` },
      ]"
    />
    <div class="page-container">
      <DocumentBreadcrumbs :crumbs="[{ name: sectionName, link: `${pathPrefix}/documents` }]" />
      <DocumentList
        :content="foldersAndDocuments"
        :is-fetching="isFetching"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '@/stores/mainStore';
import { useDocumentsData } from '../../composables/useDocumentsData';
import Breadcrumbs from '../../components/global/Breadcrumbs.vue';
import DocumentList from '../../components/DocumentList.vue';
import DocumentBreadcrumbs from '../../components/global/DocumentBreadcrumbs.vue';
import { useNuxtApp, useHead } from '#imports';

defineOptions({
  name: 'Documents',
});

const mainStore = useMainStore();
const { $t } = useNuxtApp();

mainStore.setCustomSectionData({
  type: 'documents',
  fallbackSectionName: $t('pages.documents.sectionName'),
});

const globals = computed(() => mainStore.globals);
const pathPrefix = computed(() => mainStore.pathPrefix);
const sectionName = computed(() => mainStore.sectionName);

useHead({
  title: sectionName.value,
});

const { isFetching, foldersAndDocuments } = useDocumentsData();
</script>
